module.exports = __webpack_public_path__ + "img/block1.f6fcbc31.webp";